export const fishImages = {
  // Pier
  'Lambari': '/images/fishes/lambari.png',
  'Pacu': '/images/fishes/pacu.png',
  'Sardinha': '/images/fishes/sardinha.png',
  'Tilápia': '/images/fishes/tilapia.png',
  'Traíra': '/images/fishes/traira.png',

  // Praia
  'Pescada': '/images/fishes/pescada.png',
  'Sargo': '/images/fishes/sargo.png',
  'Garoupa': '/images/fishes/garoupa.png',
  'Corvina': '/images/fishes/corvina.png',
  'Robalo': '/images/fishes/robalo.png',

  // Lago
  'Bagre': '/images/fishes/bagre.png',
  'Carpa Gigante': '/images/fishes/carpa-gigante.png',
  'Black Bass': '/images/fishes/black-bass.png',
  'Salmão': '/images/fishes/salmao.png',
  'Truta Arco-Íris': '/images/fishes/truta-arco-iris.png',

  // Rio Amazonas
  'Piranha': '/images/fishes/piranha.png',
  'Tambaqui': '/images/fishes/tambaqui.png',
  // O Pirarucu NÃO está aqui de propósito: `pirarucu.png` nunca existiu (a arte
  // nunca foi feita — prompt em docs/PROMPTS-PEIXES.md). Com a linha, o caminho
  // dava 404 e a tela mostrava imagem quebrada com o alt "Pirarucu"; sem ela,
  // `getFishImage` cai no `default-item.svg`. Quando a arte existir, volte com a
  // linha junto do arquivo em public/images/fishes/ — o teste de peixes cobra.
  'Arraia': '/images/fishes/arraia.png',
  'Acará Bandeira': '/images/fishes/acara-bandeira.png',

  // Mar Aberto
  'Atum': '/images/fishes/atum.png',
  'Peixe-Serra': '/images/fishes/peixe-serra.png',
  'Tubarão Martelo': '/images/fishes/tubarao-martelo.png',
  'Marlim Azul': '/images/fishes/marlim-azul.png',
  'Peixe-Lua': '/images/fishes/peixe-lua.png',
  'Tubarão Branco': '/images/fishes/tubarao-branco.png',
  'Cavala': '/images/fishes/cavala.png',
  'King Crab': '/images/fishes/king-crab.png',
  'Peixe-Papagaio': '/images/fishes/peixe-papagaio.png',
  'Peixe-Voador': '/images/fishes/peixe-voador.png',

  // Ilhas Cazu
  'Peixe-de-Neve': '/images/fishes/peixe-de-neve.png',
  'Peixe-Gelo': '/images/fishes/peixe-gelo.png',
  'Truta-Ártica': '/images/fishes/truta-artica.png',
  'Taimen': '/images/fishes/taimen.png',
  'Bagre-Gigante-do-Mekong': '/images/fishes/bagre-do-mekong.png',
  'Tubarão-Duende': '/images/fishes/tubarao-duende.png',
  'Peixe-Remo': '/images/fishes/peixe-remo.png',
  'Arraia-Gigante': '/images/fishes/arraia-gigante.png',
  'Celacanto': '/images/fishes/celacanto.png',
  'Esturjão-Beluga': '/images/fishes/esturjao-beluga.png',

  // Costa Dourada
  'Rêmora-Âncora': '/images/fishes/remora-ancora.png',
  'Nautilus Dourado': '/images/fishes/nautilus-dourado.png',
  'Hipocampo': '/images/fishes/hipocampo.png',
  'Medusa Imortal': '/images/fishes/medusa-imortal.png',
  'Ahuizotl': '/images/fishes/ahuizotl.png',
  'Peixe-Farol': '/images/fishes/peixe-farol.png',
  'Ipupiara': '/images/fishes/ipupiara.png',
  'Filhote de Kraken': '/images/fishes/filhote-de-kraken.png',
  'Filhote de Zaratan': '/images/fishes/filhote-de-zaratan.png',
  'Goldfish': '/images/fishes/goldfish.png',

  // Os miticos de evento — um por mapa. So aparecem enquanto o evento
  // 'legendaryShoal' que os chama estiver no ar; ver o seed em
  // packages/db/seeds/peixes/misticos.json, do lado do backend.
  'Namazu': '/images/fishes/namazu.png',
  'Sereia': '/images/fishes/sereia.png',
  'Monstro do Lago Ness': '/images/fishes/nessie.png',
  'Boitatá': '/images/fishes/boitata.png',
  'Jörmungandr': '/images/fishes/jormungandr.png',
  'Carpa-Dragão': '/images/fishes/carpa-dragao.png',
  'Cipactli': '/images/fishes/cipactli.png',

  // Default fallback image
  'default': '/default-item.svg'
};

export const getFishImage = (fishName) => {
  return fishImages[fishName] || fishImages.default;
};
